import NavigationBar from "../../components/01_navigationBar/01_navigationBar";
import Footer from "../../components/02_footer/02_footer";

import img1 from "../../assets/images/hero.png"
import "./03_Testimonials.css"

export default function Testimonials() {
    return (
        <div>
            <div className="TestimonialsPage-Flex">
                <div className="TestimonialsPage-Card">
                    <img src={img1} alt="" />
                    <div className="TestimonialsPage-Info">
                        <div className="TestimonialsPage-Stars">★★★★★</div>
                        <h3>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        </h3>
                        <p >
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent dolor erat, pulvinar in efficitur consectetur, malesuada ornare erat. 
                            </p>
                        <p className="TestimonialsPage-Name">~ Lorem ipsum</p>
                        <div className="TestimonialsPage-Keys">
                            <span className="Keywords">Lorem Ipsum</span>
                            <span className="Keywords">Lorem Ipsum</span>
                            <span className="Keywords">Lorem Ipsum</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}